module.exports = import("https://cdnjs.cloudflare.com/ajax/libs/ethers/6.10.0/ethers.js");;